import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import router from './router'
import store from './store'
import axios from 'axios'
// import './mock/mock.js'
import api from './api' // 导入接口

// 全局挂载接口对象
Vue.prototype.$api = api

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.prototype.$axios = axios

router.beforeEach((to, from, next) => {
  if (to.path === '/login') return next()
  const tokenStr = localStorage.getItem('token')
  if (!tokenStr) { 
    alert('请先登录账号再访问')
    return next('/login')
  }
  next()
})

new Vue({
  router,
  store,
  axios,
  render: h => h(App),
}).$mount('#app')
